export default __webpack_public_path__ + "static/store-google.fr-c2ea950084ec9377617ab139464ecd0c.png";